// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__r63M6","modalContainer":"Modal_modalContainer__QjqZb","modalBtn":"Modal_modalBtn__ajIhU"};